export default {
  zh: {
    defaultTitle: '请从团队树中选择某个团队',
  },
  en: {
    defaultTitle: 'Click teams tree to select a team',
  },
};
  


// WEBPACK FOOTER //
// ./src/components/ui/SelectionPool/i18n.js